import axios from 'axios';
import { AuthService } from './auth.service';
import { ENDPOINTS } from '../constants/endpoints';
import { IInstitutionSettings } from '../interfaces/institutionSettings.interface';

interface BackendSettings {
    id?: string;
    institutionId: string;
    twoFactorPolicy?: 'OPTIONAL' | 'REQUIRED';
}

const toFrontend = (data: BackendSettings): IInstitutionSettings => ({
    id: data.id,
    institutionId: data.institutionId,
    twoFactorPolicy: data.twoFactorPolicy,
});

export const InstitutionSettingsService = {
    getSettings: async (institutionId: string): Promise<IInstitutionSettings | null> => {
        const response = await axios.get<BackendSettings | null>(
            ENDPOINTS.INSTITUTION_SETTINGS.BY_INSTITUTION(institutionId),
            { headers: AuthService.getAuthHeader() }
        );
        return response.data ? toFrontend(response.data) : null;
    },

    updateTwoFactorPolicy: async (institutionId: string, policy: 'OPTIONAL' | 'REQUIRED'): Promise<void> => {
        await axios.put(ENDPOINTS.INSTITUTION_SETTINGS.TWO_FACTOR_POLICY(institutionId), { policy }, {
            headers: AuthService.getAuthHeader(),
        });
    },
};
